import classes from "./DashboardComponents.module.scss";
import {Checkout} from "@fung-sdk/checkout"
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import axios from "axios";
import ButtonLink from "../UI/ButtonLink";
import { useRef, useState } from "react";
import CurrencyTextField from '@lupus-ai/mui-currency-textfield'
import LoadingDots from "../UI/LoadingDots";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DDD } from "../../lib/ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const FungAddFunds = ({onPaymentCompleted, onClose, ...props}) => {
    const [checkoutLoading, setCheckoutLoading] = useState();
    const [value, setValue] = useState(0);
    const [error, setError] = useState();
    const [state, setState] = useState(0);
    const [checkoutId, setCheckoutId] = useState();
    const [mode, setMode] = useState("production"); //sandbox, production
    const myElementRef = useRef(null);
    /*axios.post("https://apisbx.fungpayments.com/v2/checkout/createCheckout", 
    {
      "amount": 1000,
      "currencyCode": "EUR",
      "accountId": "212100416ddcc007a1ebaadd0a8",
      "paymentProfileId" : "212100916de43007a272a0da012",
      "lineItems": [
        {
          "imageUrl": "https://strongpans.com/item/123.png",
          "name": "Titanium wok",
          "description": "Strongest pan known to humanity"
        }
      ]
    }, {
      auth: {
        username: "21210151076dd00730a83ccd019",
        password: "QC9llfbs2TVMgr9JuNLsRmEdudfJp5/AInK4ctuQb6nBr7aoOmUGatffiIuyIYe4JljssHx9wvDqPEAus4zi4I6xix+s5DMZp3Z2RikBlVHYh445VQidjVQscZMVbvgB2x0IuNyAlWGkEI4teODx+k19AyD4VaqdK5AjjnAw5yI7/GfHYrXpu4Jl+3+xCYm3wPauoOSjl/Au5gEsZvgIIcM+KH5TW03cq/b8IkuYZ6D7ck3QcgtCOzLMvT3AcFsVnLqtU0gTU8zJhX4Z+3NmFqZGLKnl7aCRqKQvbs05GaFY3KwK5WeaNcRwv904MJsO7pLQZETI2aPVQVngBWrRhg=="
      }
    });*/
    /*useEffect(() => {
        const checkout = new Checkout({
        checkoutId: "212102016e0ce007a740437a038",
        containerId: "paymentContainer",
        env: "sandbox",
        })
        checkout.on("checkout:loaded", (e) => {
            console.log(e);
        })

        checkout.on("checkout:completed", (e) => {
            console.log(e);
        })

        checkout.on("checkout:invalid", (e) => {
            console.log(e);
        })

        checkout.on("checkout:failed", (e) => {
            console.log(e);
        })
        checkout.render();
    }, []);*/
    const proceedToCheckout = () =>{
        if(checkoutLoading)
            return;
        try{
            const amount = parseFloat(value)*100;
            goToCheckout(amount);
        }catch{
            setError("Unable to resolve number");
            setTimeout(() => {setError(null);}, 5000);
        }
    }

    const goToCheckout = (amount) => {
        setCheckoutLoading(true);
        var post1 = {
            "amount": amount,
            "currencyCode": "EUR",
            "accountId": "21210041076e500730e11729087",
            //"paymentProfileId" : "21210091076e500730e116b6067", //one off, all services
            "paymentProfileId" : "21210091076e500730e116da070", //one off, single service
            //"paymentProfileId" : "21210091c290a007f07693d5010", //reccuring

            "lineItems": [
                {
                "imageUrl": "https://lh3.googleusercontent.com/proxy/_EIdlCIuMz_BqakyCgZIAo2uo7fMvqWOZm4cjhGNTQOVKdi6CF3HMjUJcBvjx4cGBY_jW0dEAx3D9JKosx0f2bipqGdL-aMifvGM_wutvP1_EGdSPm5JMTXh5KW0jrNxZaXtqN7cGw",
                "name": "DDD Invoices",
                "description": "Invoice payment"
                }
            ],
            /*recurringDetails: {
                recurringAmount: 10,
                currencyCode: 'EUR',
                recurringFrequency: 1,
                recurringExpiresAt: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString()
             }*/
        };
        var post2 = {
            "amount": 100,
            "currencyCode": "EUR",
            "accountId": "21210041076e500730e11729087",
            //"paymentProfileId": "21210091076e500730e116b6067",
            "paymentProfileId": "21210091076e500730e116da070",
            "lineItems": [
              {
                "imageUrl": "https://picsum.photos/200/300",
                "name": "Add funds",
                "description": "Add funds to your E-invoices account"
              }
            ]
          };
        /*axios.post("https://apisbx.fungpayments.com/v2/checkout/createCheckout", 
            post2, {
                auth: {
                    username: "21210151076dd00730a83ccd019",
                    password: "QC9llfbs2TVMgr9JuNLsRmEdudfJp5/AInK4ctuQb6nBr7aoOmUGatffiIuyIYe4JljssHx9wvDqPEAus4zi4I6xix+s5DMZp3Z2RikBlVHYh445VQidjVQscZMVbvgB2x0IuNyAlWGkEI4teODx+k19AyD4VaqdK5AjjnAw5yI7/GfHYrXpu4Jl+3+xCYm3wPauoOSjl/Au5gEsZvgIIcM+KH5TW03cq/b8IkuYZ6D7ck3QcgtCOzLMvT3AcFsVnLqtU0gTU8zJhX4Z+3NmFqZGLKnl7aCRqKQvbs05GaFY3KwK5WeaNcRwv904MJsO7pLQZETI2aPVQVngBWrRhg=="
                }
        }).then(res => {
            setCheckoutLoading(false);
            let checkoutId = res?.data?.id;
            loadCheckout(checkoutId);
            setCheckoutId(checkoutId);
        }).catch(res => {
            setError("Unable to contact payment service. Please contact administrator.");
            setTimeout(() => {setError(null);}, 5000);
            setCheckoutLoading(false);
        });*/
        let addFunds = {
            "Amount" : amount,
            "Type" : "AddFunds",
        }
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateFungCheckout", addFunds).then(res => {
            if(!res?.result?.Result.id){
                setError("Unable to contact payment service. Please contact administrator.");
                setTimeout(() => {setError(null);}, 5000);
                setCheckoutLoading(false);
                return;
            }
            setCheckoutLoading(false);
            let checkoutId = res?.result?.Result.id;
            setCheckoutId(checkoutId);
            loadCheckout(checkoutId);
        });
    }

    const loadCheckout = (checkoutId) => {
        setState(1);
        const checkout = new Checkout({
            checkoutId: checkoutId,
            containerId: "paymentContainerModal",
            //env: "sandbox",
            env: mode,
        })
        checkout.on("checkout:loaded", (e) => {
            
        })

        checkout.on("checkout:completed", (e) => {
            onPaymentCompleted(value, checkoutId);
            setState(2);
            clearIframeDiv();
        })
        /*checkout.on("checkout:completed", (e) => {
            onPaymentCompleted(value);
            setState(2);
            setError("Unable to resolve payment")
            setTimeout(() => {setError(null);}, 5000);
            clearIframeDiv();
        })*/

        checkout.on("checkout:invalid", (e) => {
            setState(0);
            setError("Unable to resolve payment")
            setTimeout(() => {setError(null);}, 5000);
            clearIframeDiv();
        })

        checkout.on("checkout:failed", (e) => {
            setState(0);
            setError("Unable to resolve payment")
            setTimeout(() => {setError(null);}, 5000);
            clearIframeDiv();
        })
        checkout.render();
    }

    const clearIframeDiv = () => {
        const container = document.getElementById("paymentContainerModal");
        if (container == null)return;

        container.innerHTML = null;
    }



    return(
        
        <div>
            {state === 0 && <>
                {mode==="production1" && 
                <div class="alert alert-danger" role="alert">
                    This version is in production mode!!
                </div>}
                <CurrencyTextField
                    label="Amount"
                    variant="standard"
                    value={value}
                    currencySymbol="€"
                    //minimumValue="0"
                    outputFormat="string"
                    decimalCharacter="."
                    digitGroupSeparator=","
                    onChange={(event, value)=> setValue(value)}
                    style={{width:"100%"}}
                />
                {error && 
                <div class="alert alert-danger" role="alert">
                    {error}
                </div>}
                {checkoutLoading && <LoadingDots/>}
                {!checkoutLoading && <div className="m-2 mt-4" style={{textAlign:"center"}}>
                    <ButtonLink className="px-4 py-1" onClick={proceedToCheckout}>
                        Continue
                    </ButtonLink>
                </div>
                }
            </>}
            {state ===2 && <>
                <div style={{textAlign:"center"}}>
                    <CheckCircleIcon style={{color:"green", fontSize:"3rem"}}/>
                </div>
                <div style={{textAlign:"center",color:"green", fontSize:"1rem"}}>
                    Payment successful
                </div>
                <div className="m-2 mt-4" style={{textAlign:"center"}}>
                    <ButtonLink className="px-4 py-1" onClick={onClose}>
                        Continue
                    </ButtonLink>
                </div>
            </>}
            <div id="paymentContainerModal" style={{textAlign:"center"}} ref={myElementRef}></div>
        </div>
    )
}

export default FungAddFunds;